export default __webpack_public_path__ + "static/media/BMC.17e17590.png";